import { render, staticRenderFns } from "./ChildInfo.vue?vue&type=template&id=d8666a2e&scoped=true&"
import script from "./ChildInfo.vue?vue&type=script&lang=js&"
export * from "./ChildInfo.vue?vue&type=script&lang=js&"
import style0 from "./ChildInfo.vue?vue&type=style&index=0&id=d8666a2e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8666a2e",
  null
  
)

export default component.exports